import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { TenantService } from './services/tenant.service';
import { PdfTicketContext } from './services/pdf-ticket-context.service';

@Injectable()
export class TenantInterceptor implements HttpInterceptor {

  constructor(private tenantService: TenantService, private ticketContext: PdfTicketContext) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Tenant do hostname; na página de print em origem interna (hostname não
    // resolve tenant), cai para o tenant que veio no ticket de impressão.
    const tenantId = this.tenantService.tenant?.id ?? this.ticketContext.tenantId;

    if (tenantId) {
      request = request.clone({
        setHeaders: { 'X-Tenant-Id': tenantId }
      });
    }

    return next.handle(request);
  }
}
